/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Pagina nu a fost găsită",
  "ComingSoon": "În curând",
  "YesanPersonalFinance": "Yesan, Finanțe personale",
  "Yesan": "Yesan",
  "PersonalFinance": "Finanțe personale",
  "YesanDownload": "Yesan Download",
  "ThisWebsiteUsesCookies": "Utilizăm cookie-uri pentru a colecta și analiza informații despre performanța și utilizarea site-ului nostru și pentru a oferi funcții de social media. Continuând, vă dați acordul cu",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Deveniți liber din punct de vedere financiar",
  "inStepsAndActions": "în 8 pași și 3 acțiuni.",
  "TrackPlanAnalyze": "Urmăriți. Planificați. Analizează.",
  "FTrack": "1. Urmăriți",
  "FPlan": "2. Plan",
  "FAnalyze": "3. Analiză",
  "Features": "Caracteristici",
  "FeaturesSubHeading": "Începător pur și simplu, care are deja cunoștințe financiare, aceasta este aplicația de care aveți nevoie pentru a deveni liber din punct de vedere financiar.",
  "ManageAccounts": "Gestionați conturile",
  "CashLiquidFixedAssetsLiabilities": "Numerar, lichidități, active fixe și pasive.",
  "TrackTransactions": "Urmăriți tranzacțiile",
  "IncomesExpensesTransferInvestments": "Venituri, cheltuieli, transferuri, investiții.",
  "ImportExport": "Importați / Exportați",
  "YourDataAlwaysAccessible": "Datele dvs. sunt întotdeauna accesibile.",
  "PlanYourFreedom": "Planificați-vă libertatea",
  "StepsAwayFromFI": "La 8 pași distanță de independența financiară.",
  "BudgetsAndGoals": "Bugete și obiective",
  "CheckYourProgressAndAchieve": "Verifică-ți progresul și atinge-ți obiectivele financiare.",
  "DashboardAndAnalytics": "Tablou de bord și analize",
  "ReviewLearnOptimizeWith": "Revizuiți, învățați, optimizați cu diagrame, informații, instrumente.",
  "Security": "Securitate",
  "MilitaryGradeEncryption": "Criptare de nivel militar, suport pentru biometrie, date stocate pe dispozitivele dvs.",
  "OfflineMode": "Mod offline",
  "YourDataAlwaysAccessibleAndModif": "Datele dvs. sunt întotdeauna accesibile și modificabile.",
  "Track": "Urmăriți",
  "Income": "Venituri",
  "Expense": "Cheltuieli",
  "Transfer": "Transfer",
  "transactionsAndManageAccounts": "tranzacții și gestionați o varietate de conturi:",
  "checkings": "Verificare",
  "savings": "Economii",
  "realEstate": "Imobiliare",
  "stocks": "Burse de valori",
  "bonds": "Obligațiuni",
  "crypto": "Criptomonede",
  "notes": "Bancnote, numerar Portofel",
  "envelopes": "Plicuri",
  "privateEquity": "Capital privat",
  "metal": "Metal",
  "retirement": "Pensionare",
  "lifeInsurance": "Asigurări de viață",
  "intellectualProperty": "Proprietatea intelectuală",
  "otherLiquidAsset": "Alte active lichide",
  "otherFixedAsset": "Alte active fixe",
  "mortgage": "Ipotecă",
  "loan": "Împrumut de consum",
  "creditCard": "Carte de credit",
  "otherLiability": "Alt pasiv",
  "AccountsManagement": "Gestionarea conturilor",
  "MultipleAccountsTypesAndGrouping": "Tipuri de conturi multiple și grupare",
  "LinkAccounts": "Conectarea conturilor de la instituțiile dumneavoastră (disponibil numai în anumite țări)",
  "SmartAccounts": "Conturi inteligente",
  "AddEditDeleteTransactions": "Adăugare / Editare / Ștergere de tranzacții",
  "TickVerifiedTransactions": "Bifați tranzacțiile verificate",
  "CategorizeTransactions": "Clasificați tranzacțiile pe categorii",
  "TagTransactions": "Etichetați tranzacțiile",
  "TrackKakeiboType": "Urmăriți tipul Kakeibo",
  "TrackInvestments": "Urmăriți investițiile (disponibil doar în anumite țări)",
  "ImportFromCSVFile": "Importați tranzacțiile în întregime sau în mod incremental dintr-un fișier CSV",
  "ExportToCSVFile": "Exportați tranzacțiile în fișier CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "Plan de 8 pași către independența financiară, buget detaliat, atingeți-vă mai repede obiectivele financiare.",
  "levelsTowardsFI": "8 trepte către independența financiară",
  "EstablishBudgetsPer": "Stabiliți bugete pe",
  "account": "cont",
  "accountType": "tip de cont",
  "KakeiboType": "Tipul de cont",
  "category": "categorie",
  "tag": "tag",
  "label": "etichetă",
  "TrackBudgetsPerFrequency": "Urmăriți bugetele pe frecvență",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Creați obiective privind cheltuielile, soldul, fluxul de numerar, acțiunile",
  "TrackGoalsProgress": "Urmăriți progresul obiectivelor",
  "ReviewLearnOptimizeWithReportsCharts": "Revizuiți, învățați, optimizați cu ajutorul rapoartelor, graficelor, tendințelor, perspectivelor, instrumentelor.",
  "Dashboard": "Tablou de bord",
  "FSNetWorth": "Situații financiare: Valoare netă",
  "FSPnL": "Situații financiare: Contul de venituri / Profit și pierderi",
  "FSBalanceSheetAssetsLiabilities": "Situații financiare: Bilanț, active, pasive",
  "FSCashFlow": "Situații financiare: Situația fluxurilor de numerar, debit-credit, fluxuri",
  "FSFlows": "Situații financiare: Fluxuri",
  "FSRatios": "Situații financiare: Ratios",
  "TrendsMonthEnd": "Tendințe la sfârșitul lunii: Venituri și cheltuieli, flux de numerar",
  "TrendsPerformance": "Tendințe în materie de performanță: YoY, MoM, WoW",
  "IncomeTrendsPer": "Tendințe ale veniturilor pe",
  "SpendingTrendsPer": "Tendințe în materie de cheltuieli per",
  "RecurringItemsIE": "Elemente recurente: Venituri și cheltuieli",
  "DebtProgressTrends": "Tendințe privind evoluția datoriei",
  "KakeiboMTDReviewTrends": "Kakeibo: Revizuirea MTD, ultima lună, tendințe",
  "FIWCLE": "Independența financiară: Grafic de perete, cheltuieli în funcție de energia vieții",
  "DebtPaydownSnowballAvalanche": "Reducerea datoriilor: Bulgăre de zăpadă, Avalanșă",
  "FullyCustomizableAnalyticsRange": "Interval de timp complet personalizabil pentru analiză",
  "ContactUs": "Contactați-ne",
  "Privacy": "Confidențialitate",
  "Terms": "Termeni",
  "About": "Despre",
  "IAgreeToThe": "Sunt de acord cu",
  "AndThe": "și cu",
  "PrivacyPolicy": "Politica de confidențialitate",
  "TermsOfUse": "Termenii de utilizare",

  "DigitalSoftwareExperienceTagline": "Experiență software digitală pentru lumea modernă",
  "DigitalExperience": "Experiența digitală",
  "SoftwareForTheModernWorld": "Software pentru lumea modernă",
  "MobileApplications": "Aplicații mobile",
  "forConnectedAndOfflineHumans": "pentru oamenii conectați și offline",
  "CloudSaaS": "Cloud SaaS",
  "ResponsiveAndWebServices": "Servicii responsive și servicii web",
  "PersonalFinanceServices": "Servicii financiare personale",
  "YS_p1": "Yesan este o companie de software dinamică, specializată în dezvoltarea de aplicații mobile de ultimă generație, adaptate pentru consumatori. Cu o înțelegere profundă a nevoilor și preferințelor în continuă evoluție ale utilizatorilor de astăzi, Yesan este dedicată creării de experiențe mobile intuitive, atractive și bogate în funcții care îmbogățesc viața utilizatorilor săi.",
  "YS_p2": "În centrul misiunii Yesan se află un angajament neobosit față de inovație și creativitate, fiecare produs fiind meticulos conceput pentru a oferi o funcționalitate fără cusur și o experiență de utilizare excepțională.",
  "PersonalFinanceApplication": "Aplicație de finanțe personale",
  "YPF_p1": "Yesan, Personal Finance este o aplicație mobilă de ultimă generație pentru finanțe personale, concepută pentru a le oferi utilizatorilor instrumente complete de gestionare financiară accesibile în mod convenabil la îndemână. Cu o interfață elegantă și intuitivă, Yesan, Personal Finance oferă o abordare holistică a gestionării finanțelor, adresându-se utilizatorilor de toate nivelurile de cunoștințe financiare.",
  "YPF_p2": "Printre caracteristicile cheie se numără urmărirea bugetului, clasificarea cheltuielilor și monitorizarea tranzacțiilor în timp real, permițând utilizatorilor să obțină informații despre obiceiurile lor de cheltuieli fără efort. Aplicația oferă, de asemenea, opțiuni de bugetare personalizabile, permițând utilizatorilor să își stabilească obiective financiare și să își urmărească progresul în timp.",
  "YPF_p3": "În plus, Yesan, Personal Finance acordă prioritate securității, utilizând protocoale de criptare de ultimă generație pentru a proteja informațiile financiare sensibile ale utilizatorilor. Cu măsuri de securitate de nivel bancar, utilizatorii își pot lega cu încredere conturile și sincroniza tranzacțiile fără a compromite confidențialitatea.",
  "YPF_p4": "Yesan, Personal Finance merge dincolo de bugetarea de bază, oferind analize pătrunzătoare și recomandări personalizate pentru a optimiza deciziile financiare. Fie că este vorba de identificarea potențialelor oportunități de economisire, de monitorizarea portofoliilor de investiții sau de gestionarea strategiilor de rambursare a datoriilor, aplicația oferă informații personalizate pentru a ajuta utilizatorii să își atingă obiectivele financiare.",
  "Discover": "Descoperiți",
  "Firstname": "Prenume",
  "Lastname": "Numele de familie",
  "Company":"Compania",
  "Subject": "Subiect",
  "Email": "Email",
  "Message": "Mesaj",
  "ThankYouForContactingUs": "Vă mulțumim că ne-ați contactat",
  "ValidFirstnameRequired": "Este necesar un prenume valid.",
  "ValidLastnameRequired": "Este necesar un nume de familie valid.",
  "ValidEmailAddressRequired": "Vă rugăm să introduceți o adresă de e-mail validă.",
  "ValidSubjectRequired": "Vă rugăm să selectați un subiect valid.",
  "ValidMessageRequired": "Vă rugăm să introduceți un mesaj valid.",
  "UnableToSendTheFormPleaseRetryLater": "Nu se poate trimite formularul, vă rugăm să încercați din nou mai târziu.",
  "Information": "Informații",
  "Sales":"Vânzări",
  "Support": "Asistență",
  "Press": "Apăsați",
  "Partnership": "Parteneriat",
  "Other": "Altele",
  "Blog":"Blog",

  "Accept":"Acceptă",
  "Decline":"Refuzați",

  "WorklogCalendar":"Calendar Worklog pentru Jira",

  "DirectlyAccessibleInProjectApps":"Acces direct în aplicațiile de proiect",
  "VisualizeWhereYouSpentYourTime":"Vizualizați unde v-ați petrecut timpul",
  "AllYourWorklogsInACalendar":"Toate jurnalele dvs. de lucru într-un calendar",
  "MonthSummary":"Rezumatul lunii",
  "CheckIfYouForgotToLogTime":"Verificați dacă ați uitat să înregistrați timpul.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Accesați direct problemele și actualizați timpul",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Faceți clic pe elementul din jurnalul de lucru pentru a accesa direct problemele și pentru a vă edita timpul urmărit",
  "AlsoAvailableInDarkMode":"Disponibil și în modul întunecat",
  "DirectlyLogWorkOnTheCalendarVisually":"Înregistrați munca direct pe calendar vizual",
  "ClickOnTheCalendarToCreateNewWorklog":"Faceți clic pe calendar pentru a crea un nou jurnal de lucru",

  "AppsForAtlassian":"Aplicații pentru Atlassian",
  "YCL_p1":"Vizualizați toate registrele de lucru pe un calendar cu vizualizări lunare, săptămânale, săptămânale de lucru, zilnice.",
  "YCL_p2":"Înregistrați munca direct din calendar selectând vizual intervalul de timp.",
  "YCL_p3":"Identificați dacă ați uitat să urmăriți timpul pentru foile dvs. de pontaj.",
  "YCL_p4":"Disponibil în limba dvs: Engleză (Marea Britanie), Engleză (SUA), chineză (simplificată), chineză (tradițională), cehă, daneză, olandeză, estonă, finlandeză, franceză, germană, maghiară, islandeză, italiană, japoneză, coreeană, norvegiană, poloneză, portugheză (Brazilia), portugheză (Portugalia), rusă, spaniolă, suedeză, turcă.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Portofoliu financiar pentru Jira",
  "BringRealFinancialPortfolio":"Aduceți gestionarea reală a portofoliului financiar în Jira. Urmăriți bugetele, cheltuielile de capital (CapEx) și cheltuielile operaționale (OpEx), precum și costurile proiectelor dintr-un singur loc.",
  "YFPAboutQ":"Cât ne costă de fapt proiectele noastre Jira?",
  "YFPAbout":"Portofoliu financiar pentru Jira\nLiderii financiari și PMO-urile se străduiesc să răspundă la o întrebare simplă:\nCât ne costă de fapt proiectele noastre Jira?\nJira urmărește activitatea.\nDepartamentul financiar urmărește bugetele.\nAceastă aplicație le conectează în sfârșit pe cele două.\n\nPortofoliul financiar transformă Jira într-o platformă ușoară de PPM + planificare financiară — fără a fi nevoie de instrumente enterprise costisitoare.",
  "YFPPorfolioQ":"Bugete și urmărire portofoliu",
  "YFPPorfolioP":"Creați portofolii pentru mai multe proiecte Jira și definiți: suma bugetului, moneda, intervalul de date, proiectele incluse, echipele. Urmăriți automat costurile reale pe măsură ce activitatea se desfășoară în Jira.",
  "YFPPorfolioListQ":"Portofolii",
  "YFPPorfolioListP":"Creați portofolii financiare care combină mai multe proiecte Jira și vedeți instantaneu: buget vs cost real, rata de consum a proiectului în timp real, defalcarea CapEx vs OpEx, costul pe problemă și pe proiect, rapoarte financiare exportabile. Toate alimentate direct de jurnalele de lucru Jira.",
  "CostQ":"Calcul automat al costurilor",
  "CostP":"Transformați urmărirea timpului în date financiare reale. Aplicația: citește jurnalele de lucru Jira, aplică tarife orare, calculează zilnic costurile reale ale proiectului. Fără foi de calcul. Fără muncă manuală.",
  "RatesQ":"Tarife",
  "RatesP":"Setați tariful orar pe proiect, echipă, la nivel global",
  "ReportQ":"Raportare financiară CSV",
  "ReportP":"Exportați datele financiare ale portofoliului în câteva secunde. Perfect pentru: echipe financiare, raportare către directorul financiar, planificare bugetară, asistență pentru audit",
  "SettingsQ": "Clasificare CapEx vs OpEx",
  "SettingsP": "Respectă cerințele contabile și de audit. Clasifică activitatea în: dezvoltare capitalizabilă (CapEx), activitate operațională (OpEx). Generează rapoarte exportabile, gata pentru echipele financiare."
};

export const documents = {
};
